import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router/index.js";
import store from "@/store/index.js";
import vuetify from "@/plugins/vuetify.js";
import { loadFonts } from "@/plugins/webfontloader";
import { emitter } from "./emitter";
import PrimeVue from "primevue/config";
import Material from "@primevue/themes/material";

loadFonts();

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* 
   import specific icons 
   원하는 아이콘을 개별적으로 import
*/
import { fas } from "@fortawesome/free-solid-svg-icons";
/* import font awesome 컴포넌트 */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* 위에서 import한 아이콘들을 Core library에 등록 */
library.add(fas);

const app = createApp(App);

app.component("font-awesome-icon", FontAwesomeIcon);
app.config.globalProperties.$emitter = emitter;

app.use(router).use(store).use(vuetify).mount("#app");

app.use(PrimeVue, {
    theme: {
        preset: Material,
    },
});
